
export const environment = {
    production: true,
    apiUrl: 'https://auction-backoffice-api.qa.omakase.transcode.co.th',
    siteKey: '6LdenVgcAAAAAL4C9mU3hHRuH3HujGNx5iwMZwWj',
    secretKey: '6LdenVgcAAAAAITruBXGyfUl6T_4jxZ77m01bId2',
    media_image: 'https://media.omakasecar.com/',
    version: '1.1.1.3'
};
